export default __webpack_public_path__ + "static/media/Belt of Ferine Anger.5e7297da.jpg";